module.exports = __webpack_public_path__ + "img/logo_100.e4d55832.svg";